import React from 'react';
import { motion } from 'framer-motion';
import {
  Users,
  Heart,
  Brain,
  Activity,
  Scan,
  Bone,
  Wind,
  Stethoscope,
} from 'lucide-react';

const Specialties = () => {
  const specialties = [
    { icon: Users, name: 'Family Practice' },
    { icon: Heart, name: 'Cardiology' },
    { icon: Brain, name: 'Behavioral/Mental Health' },
    { icon: Activity, name: 'Physical Therapy' },
    { icon: Scan, name: 'Dermatology' },
    { icon: Bone, name: 'Orthopedics' },
    { icon: Wind, name: 'Chiropractic' },
    { icon: Stethoscope, name: 'Urgent Care' },
  ];

  return (
    <section id="specialties" className="py-32 bg-gradient-to-br from-slate-50 to-white">
      <div className="container mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-100px' }}
          transition={{ duration: 0.6 }}
          className="text-center mb-20"
        >
          <div className="text-[#14b8a6] font-semibold text-sm tracking-wider uppercase mb-4">
            Specialized Expertise
          </div>
          <h2 className="text-5xl lg:text-6xl font-bold text-slate-900 mb-6">
            Specialties We Serve
          </h2>
          <p className="text-xl text-slate-600 max-w-3xl mx-auto">
            Deep expertise across medical specialties with dedicated coding knowledge
            for your practice area.
          </p>
        </motion.div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
          {specialties.map((specialty, index) => {
            const Icon = specialty.icon;
            return (
              <motion.div
                key={index}
                initial={{ opacity: 0, scale: 0.8 }}
                whileInView={{ opacity: 1, scale: 1 }}
                viewport={{ once: true, margin: '-100px' }}
                transition={{ delay: index * 0.05, duration: 0.4 }}
                whileHover={{ y: -10, scale: 1.05 }}
                className="bg-white rounded-2xl p-8 border-2 border-slate-100 hover:border-[#14b8a6]/30 transition-all duration-300 hover:shadow-xl cursor-pointer group"
              >
                <motion.div
                  whileHover={{ scale: 1.2, rotate: 10 }}
                  transition={{ duration: 0.3 }}
                  className="w-16 h-16 rounded-xl bg-gradient-to-br from-[#1e3a8a]/10 to-[#14b8a6]/10 flex items-center justify-center mx-auto mb-4 group-hover:from-[#1e3a8a]/20 group-hover:to-[#14b8a6]/20"
                >
                  <Icon size={32} className="text-[#1e3a8a]" />
                </motion.div>
                <h3 className="text-center font-semibold text-slate-900 group-hover:text-[#1e3a8a] transition-colors">
                  {specialty.name}
                </h3>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Specialties;
